import {Component, OnDestroy, OnInit} from '@angular/core';
import {Observable, Subject} from 'rxjs';
import {ActivatedRoute, Router} from '@angular/router';
import {select, Store} from '@ngrx/store';
import {IDac6ReporterState} from '../../store/reducers/dac6-reporter.reducer';

import {takeUntil, take} from 'rxjs/operators';
import {
  getApplications,
  getCurrentBasket,
  getViewType,
  ParticleState
} from '@shared/store/reducers/particle.reduer';
import {ParticleService} from '@core/services/particle.service';
import {getSmartGridFieldSectionInfos} from '@shared/store/selectors/smart-grid.selectors';
import {InvalidateSubject} from '@shared/helpers/invalidate.subject';
import {CommandService} from '@core/services/command.service';
import {SnackBarService} from '@core/services/snack-bar.service';
import {DialogService} from '@shared/services/dialog-service';
import {BreadcrumbModel} from '@shared/models/breadcrumb.model';
import {
  ArrangeMentsDeleteCommand,
  CreateArrangementCommand,
  UpdateArrangementCommand,
  CreateMonthlyFilingCommand,
  SyncProjectEntityToCompanyCommand,
  CreatePreArrangementCommand,
  MarkAnnualFilingCommand, CreateQuarterlyFilingCommand, CopyOrMoveForFilingCommand,
  SaveSelectedArrangementsInLeftSideOfTheTransferboxCommand,
  CreateArrangementFromExistingCaseCommand,
  ArchiveCaseCommand,
  SaveSelectedCaseModelsInLeftSideOfTheTransferboxCommand,
  UnarchiveCaseCommand,
  ArchiveSingleCaseCommand
} from '../../commands/dac6-reporter.command';
import {Configuration} from '@shared/models/configuration';
import {ParticleConfig} from '../../../particle-config';
import {UpdateFieldDefinitionCommand} from '@shared/commands/update-field-definition.command';
import {IQueryState} from '@shared/store/reducers/query.reducer';
import {getQueryResponse} from '@shared/store/selectors/query.selector';
import {QueryProvider} from '@shared/queries/query-provider';
import {DialogModel} from '@shared/models/dialog.model';

import {SetViewTypeAction} from '@shared/store/actions/particle.actions';
import {getVirtualGridSelectedIndex} from '@shared/store/selectors/virtual-grid.selector';
import {CollaborationState} from '../../../task-manager/collaboration/store/collaboration.reducer';
import {
  CreateChatConversationCommand
} from '../../../task-manager/collaboration/store/collaboration.command';
import {ContentScope, PlatformCommand} from '@shared/commands/command-base';
import {
  ConversationComponentName
} from '../../../task-manager/collaboration/store/collaboration.constants';
import {
  CreateChatConversationAction,
  CreateConversationAction
} from '../../../task-manager/collaboration/store/collaboration.action';
import {FormBuilder} from '@angular/forms';
import {Dac6ReporterApiService} from '../../services/dac6-reporter.service';
import {RowClassArgs} from '@progress/kendo-angular-grid';
import {FilingTypes} from '@shared/constants/FilingTypes';
import {FilingPeriod} from '@shared/constants/FilingPeriod';
import {ArrangementFields, CommonFields, FilingStages} from '@shared/constants/ArrangementConstants';
import {Guid} from 'guid-typescript';
import {
  ItemSelectionChangedAction,
  Dynamic_Grid_Data_Request_Parameters
} from '@shared/store/actions/virtual-grid.actions';
import {$} from 'protractor';
import { FuseSplashScreenService } from '@barebone-fuse-services/splash-screen.service';
import {BasketModel} from '@shared/models/common.models';
import {BasketProvider} from '@shared/models/basket-provider';
import {BasketId} from "../../Fields";
import {ArrangementBasketHelper} from "./ArrangementBasketHelper";
import {ParticleCacheService} from "@core/services/particle-cache.service";
import {SetActivityFeedAction} from "@shared/components/platform-sidebar/store/platform-sidebar.action";
import {PlatformSidebarState} from "@shared/components/platform-sidebar/store/platform-sidebar.reducer";
import { FileStoreCommonService } from '@features/file-manager/services/file-store-common.service';


@Component({
    standalone: false,
    selector: 'lib-arrangement-content',
  templateUrl: './arrangement-content.component.html',
  styleUrls: ['./arrangement-content.component.scss']
})
export class ArrangementContentComponent implements OnInit, OnDestroy {
  sourceType: string;
  currentSelectedItems: string[];
  flag: boolean;
  deleteDisabled: boolean;
  numberOfTabs$: Observable<any>;
  unSubscribe$ = new Subject<void>();
  hasNoExtraTab = true;
  invalidateSubject: InvalidateSubject;
  breadcrumbs: BreadcrumbModel[];
  breadcrumbs$: Observable<BreadcrumbModel[]>;
  tabs: any[];
  selectedTab: any;
  actions: any[];
  viewType: string;
  private selectedFieldSectionIndex$: Observable<number>;
  private selectedTabIndex: number;
  filterId: string;
  endpoint: string = 'Dac6Api';
  filedPeriod: string = 'notfiled';
  private config: any;
  inputForm: any;
  fieldHistorySourceType: string = 'Dac6-Field-History';
  showArchived: boolean;
  selectedBasket: BasketModel;
  showAnnouncement: boolean = false;
  announcementContent: string = '';

  constructor(private router: Router, private store: Store<IDac6ReporterState>,
              private particleService: ParticleService,
              private particleCacheService: ParticleCacheService,
              private particleStore: Store<ParticleState>,
              protected commandService: CommandService,
              private activatedRoute: ActivatedRoute,
              private snackBarService: SnackBarService,
              private dialogService: DialogService,
              private platformSidebarStore: Store<PlatformSidebarState>,
              private queryState: Store<IQueryState>,
              private collaborationStore: Store<CollaborationState>,
              private formBuilder: FormBuilder,
              private dac6ReporterApiService: Dac6ReporterApiService,
              private fuseSplashScreenService: FuseSplashScreenService,
              private fileStoreCommonService: FileStoreCommonService
  ) {
    this.showArchived = false;
    this.tabs = [];
    this.viewType = 'Expanded';
    this.actions = [
      {
        text: 'Create Case',
        doAction: this.createCase,
        self: this
      },
      {
        text: 'Import',
        doAction: this.import,
        self: this
      },
      {
        text: 'Export',
        doAction: this.export,
        self: this
      },
      {
        text: 'Manage Fields',
        doAction: this.manageSection,
        self: this
      },
      {
        text: 'Start Survey',
        doAction: this.startDataSurvey,
        self: this
      }
    ];
    this.selectedTabIndex = -1;
    this.sourceType = 'Arrangement';
    this.invalidateSubject = new InvalidateSubject();
    this.inputForm = this.formBuilder.group({
      value: ['']
    });
    this.inputForm.valueChanges.subscribe(() => {

    });
    this.breadcrumbs = [
      <BreadcrumbModel>{
        id: 'Case',
        title: 'DAC6 & MDR Reporter',
        type: 'Case',
        relativeUrl: 'dac6-reporter/overview',
        children: []
      },
      <BreadcrumbModel>{
        id: 'Arrangement',
        title: 'Arrangement',
        type: 'Arrangement',
        relativeUrl: 'dac6-reporter/arrangement',
        children: []
      },
      <BreadcrumbModel>{
        id: 'notfiled',
        title: 'Not Filed',
        type: 'DropDown',
        relativeUrl: 'dac6-reporter/arrangement',
        children: []
      }
    ];
  }

  ngOnInit() {
    if (this.activatedRoute.snapshot.params.filedPeriod) {
      this.filedPeriod = this.activatedRoute.snapshot.params.filedPeriod;
    }
    this.dac6ReporterApiService.getArrangementBreadcrumbs().pipe(takeUntil(this.unSubscribe$)).subscribe(breadcrumbs => {
      if (breadcrumbs) {
        this.breadcrumbs[2].children = breadcrumbs;
        const selectedBreadCrumb = this.breadcrumbs[2].children.find(o => o.id === this.filedPeriod);
        this.setActiveFilingType(selectedBreadCrumb);
        this.router.navigateByUrl(selectedBreadCrumb.relativeUrl);
      }
    });
    this.config = Configuration.getSmartGridConfig(this.sourceType);
    this.config.Parameters['FILED_PERIOD'] = this.filedPeriod;
    this.config.Parameters['SHOW_ARCHIVED'] = this.showArchived;
    this.particleCacheService.saveUserPreferenceGridSetting(Dynamic_Grid_Data_Request_Parameters, this.sourceType, this.config.Parameters);
    this.activatedRoute.params.subscribe((params: any) => {
      if (params.filedPeriod) {
        if (this.breadcrumbs[2].children && this.breadcrumbs[2].children.length > 0) {
          const selectedBreadCrumb = this.breadcrumbs[2].children.find(o => o.id === params.filedPeriod);
          if (this.filedPeriod !== params.filedPeriod) {
            this.setActiveFilingType(selectedBreadCrumb);
            this.filedPeriod = params.filedPeriod;
            this.invalidateSubject.invalidate();
          }
        }
      }
    });
    this.currentSelectedItems = [];
    this.flag = false;
    this.deleteDisabled = true;
    this.particleStore.pipe(select(getViewType)).subscribe(viewType => {
      this.viewType = viewType;
    });

    this.selectedFieldSectionIndex$ = this.store.pipe(select(getVirtualGridSelectedIndex, this.sourceType));
    this.selectedFieldSectionIndex$.pipe(takeUntil(this.unSubscribe$)).subscribe(state => {
      if (state >= 0 && state < this.tabs.length) {
        this.selectedTab = this.tabs[state];
      }
      this.selectedTabIndex = state;
    });
    this.particleStore.pipe(select(getCurrentBasket), takeUntil(this.unSubscribe$)).subscribe((item: BasketModel) => {
      if (item) {
        this.selectedBasket = item;
      }
    });
    this.announcementContent = '<p><i class="far fa-info-circle"></i> <strong>Note:</strong> For United Kingdom, only the category D Hallmarks are applicable. Please&nbsp;\n<a href="https://s3-us-west-2.amazonaws.com/orbitaxservices.com/dac6/download/uk-dac6-faq.pdf" target="_blank">download the FAQs document</a>&nbsp;for details.</p>';

    // const activityInfo = {type: 'Tool', 'id': 'dac6-arrangements', 'title': 'Arrangements', isDefault: true};
    // this.platformSidebarStore.dispatch(new SetActivityFeedAction(activityInfo));
  }

  viewTypeChanged($event) {
    this.particleStore.dispatch(new SetViewTypeAction($event));
  }

  compactViewType() {
    this.particleStore.dispatch(new SetViewTypeAction('Compact'));
  }

  onFieldSectionChanged($event) {
    if ($event) {
      if (this.tabs.length) {
        this.tabs.splice(0, this.tabs.length);
      }
      let index = 0;
      if ($event.length > 0) {
        $event.forEach(f => {
          this.tabs.push({id: f.id, header: f.header, index: index++, headerKey: f.headerKey});
        });
        if (!this.selectedTab) {
          if (this.selectedTabIndex >= 0) {
            this.selectedTab = this.tabs[this.selectedTabIndex];
          } else {
            this.selectedTab = this.tabs[0];
          }
          // this.invalidateSubject.invalidate(`Selected Index: ${this.selectedTab.index}`);
        }
      }
    }
  }

  onSelectedTabChanged($event) {
    this.selectedTab = $event;
    this.invalidateSubject.invalidate(`Selected Index: ${this.selectedTab.index}`);
  }

  onCellEditorClosed(event) {
    console.log(event);
    this.router.navigate(['']);
  }

  onSelectionChanged(event) {
    if (this.flag) {
      this.currentSelectedItems = [];
    }
    this.flag = false;
    event.deselectedRows.forEach(item => {
      const index = this.currentSelectedItems.indexOf(item.dataItem.id);
      if (index > -1) {
        this.currentSelectedItems.splice(index, 1);
      }
    });
    event.selectedRows.forEach(item => {
      this.currentSelectedItems.push(item.dataItem.id);
    });
    if (this.currentSelectedItems.length > 0) {
      this.deleteDisabled = false;
    } else {
      this.deleteDisabled = true;
    }

  }

  addSection() {
    this.router.navigate(['add-section/' + 'Arrangement'], {relativeTo: this.activatedRoute});
  }

  manageSection() {
    const command = new PlatformCommand('CreateManageFieldMagicLinkCommand', 'Dac6Api');
    command.fieldValues['SourceType'] = Configuration.getBasketMappedSourceType('Arrangement');
    this.commandService.executePlatformCommand(command).pipe(take(1)).subscribe(response => {
        console.log('commandState', response);
        if (response.fieldValues['RedirectUrl']) {
          this.router.navigateByUrl(response.fieldValues['RedirectUrl']);
        }
      },
      error => {
        this.fuseSplashScreenService.hide();
        console.error('Failed to arrangement manage section', error);
      });
  }

  export() {
    this.router.navigate(['export'], {
      relativeTo: this.activatedRoute,
      queryParams: {
        includeArchives: this.showArchived
      }
    });
  }
  private trackCaseActiviy(event: any) {
  this.platformSidebarStore.dispatch(new SetActivityFeedAction({type: 'ReferenceCode', id: event.item.cells['ReferenceCode'].value, title: event.item.cells['CaseId'].value, isDefault: false, isUserAction: true}));
}
  createCase() {
    const dialogModel: DialogModel = DialogModel.create(
      'Create Case',
      'CreateCaseDialogComponent', {'caseType': 'Arrangement', disableTypeChange: true},
      '600px',
      '700px'
    );
    this.dialogService.showOkCancelDialog(dialogModel).subscribe(res => {
      console.log(res);
      if (res.action === 'OK') {
        switch (res.data.input.caseType) {
          case 'PreArrangement':
            this.addPreArrangement(res.data.input.title);
            break;
          case 'Arrangement':
            if (res.data.input.specifyField) {
              res.data.input.archiveExisting = false;
              this.openSelectFieldDialog(res.data.input.selectedCase, 'arrangementmodel', 'Arrangement', res, res.data.input.selectedCase);
            } else {
              if (res.data.input.selectedCase) {
                this.addArrangementFromExistingCaseId(res.data.input.title, res.data.input.selectedCase, false, false);
              } else {
                this.addArrangement(res.data.input.title);
              }
            }
            break;
        }
      }
    });
  }

  addArrangement(title: string) {
    this.fuseSplashScreenService.show();
    this.commandService.executeCommand(new CreateArrangementCommand(title)).pipe().subscribe(state => {
      this.fuseSplashScreenService.hide();
      this.router.navigateByUrl(`dac6-reporter/arrangement/${state.Payload.Id}`);
    });
  }

  addArrangementFromExistingCaseId(title: string, existingCaseId: string, archiveExisting: boolean, caseIdForCorrection: boolean, copyCount?: number, selectedFields?: string[], copyAllFields: boolean = true) {
    this.fuseSplashScreenService.show();
    this.commandService.executeCommand(new CreateArrangementFromExistingCaseCommand(title, existingCaseId, archiveExisting, caseIdForCorrection, copyCount, selectedFields, copyAllFields)).pipe().subscribe(state => {
      this.fuseSplashScreenService.hide();
      this.router.navigateByUrl(`dac6-reporter/arrangement/detail/${state.Payload.Id}`);
    });
  }


  archiveSingle(caseGuid: string) {
    const dialogModel = DialogModel.create('Archive Case',
      'ArchiveDialogComponent',
      {}, '500px', '490px', false);
    dialogModel.okCaption = 'Archive';
    this.dialogService.showOkCancelDialog(dialogModel).pipe(takeUntil(this.unSubscribe$)).subscribe(data => {
      if (data.action === 'OK') {
        console.log(data.data.input['comment']);
        let command = new ArchiveSingleCaseCommand(caseGuid, data.data.input['comment']);
        this.fuseSplashScreenService.show();
        this.commandService.executeCommand(command).subscribe(state => {
          this.invalidateSubject.invalidate();
          this.fuseSplashScreenService.hide();
        });
      }
    });
  }

  unarchiveCase(caseGuid: string) {
    const message = 'You can unarchive this Case if you need to make additional edits, or if it was archived by mistake. Please ensure that any associated Tasks and Reports are updated and re-opened as required.';
    const question = 'Are you sure you want to unarchive this DAC6 Case?';
    this.dialogService.showConfirmDialog('Unarchive', 'Unarchive', 'Cancel', message, question).subscribe(data => {
      if (data.action === 'OK') {
        var command = new UnarchiveCaseCommand(caseGuid);
        this.fuseSplashScreenService.show();
        this.commandService.executeCommand(command).subscribe(state => {
          this.invalidateSubject.invalidate();
          this.fuseSplashScreenService.hide();
        });
      }
    });
  }

  archive() {
    let selectionKey = 'arrangement-archive-cases';
    let input = {
      ['SELECTION_KEY']: selectionKey,
      ['ITEMS_SOURCE_TYPE']: this.sourceType
    };
    let filterId = selectionKey;
    const basketSourceType = BasketProvider.getBasketMappedSourceType(this.sourceType);
    let preCommand = new SaveSelectedCaseModelsInLeftSideOfTheTransferboxCommand(selectionKey, filterId, basketSourceType);
    this.commandService.executeCommand(preCommand).subscribe(prestate => {
      if (prestate) {
        const dialogModel = DialogModel.create('Select', 'EntitySelectorDialogComponent', {
          filterId: selectionKey,
          filterTemplateId: 'arrangement-archive-filter',
          apiKey: 'Dac6Api',
          input: input
        });
        dialogModel.minWidth = '1200px';
        dialogModel.maxWidth = '1200px';
        dialogModel.okCaption = 'Next';
        this.dialogService.showOkCancelDialog(dialogModel)
          .pipe(takeUntil(this.unSubscribe$))
          .subscribe(actionState => {
            if (actionState && actionState.action === 'OK') {
              this.showArchiveDialog(filterId, selectionKey);
            }
          });
      }
    });
  }

  showArchiveDialog(filterId, selectionKey) {
    const dialogModel = DialogModel.create('Archive Case(s)',
      'ArchiveDialogComponent',
      {}, '500px', '490px', false);
    dialogModel.okCaption = 'Archive';
    this.dialogService.showOkCancelDialog(dialogModel).pipe(takeUntil(this.unSubscribe$)).subscribe(data => {
      if (data.action === 'OK') {
        console.log('Clicked Okay');
        console.log(data.data.input['comment']);
        let command = new ArchiveCaseCommand(filterId, selectionKey, this.sourceType, data.data.input['comment']);
        this.fuseSplashScreenService.show();
        this.commandService.executeCommand(command).subscribe(state => {
          this.invalidateSubject.invalidate();
          this.fuseSplashScreenService.hide();
        });
      }
    });
  }
  sendShowArchivedActivityCommand() {
    let showArchivedCommand = new PlatformCommand('ShowArchivedCommand','Dac6Api');
    var sourceKey = BasketProvider.getRootSourceKeyBySourceType(this.sourceType);
    showArchivedCommand.fieldValues['SourceType'] = sourceKey;
    showArchivedCommand.fieldValues['IsArchived'] = this.showArchived;
    // viewDocumentCommand.fieldValues[sourceKey+"Id"] = event.item.id;
    this.commandService.executePlatformCommand(showArchivedCommand).pipe(take(1)).subscribe(response => {
        console.log('commandState', response);
      },
      error => {
        console.error('Failed to basket manage section', error);
      });
  }

  showArchivedChanged() {
    this.fuseSplashScreenService.show();
    console.log('showArchivedChanged');
    const config = Configuration.getSmartGridConfig(this.sourceType);
    config['Parameters']['SHOW_ARCHIVED'] = this.showArchived;
    this.sendShowArchivedActivityCommand();
    this.particleCacheService.saveUserPreferenceGridSetting(Dynamic_Grid_Data_Request_Parameters, this.sourceType, config['Parameters']);
    this.invalidateSubject.invalidate();
    this.fuseSplashScreenService.hide();
  }

  addPreArrangement(title: string) {
    this.fuseSplashScreenService.show();
    this.commandService.executeCommand(new CreatePreArrangementCommand(title)).pipe().subscribe(state => {
      this.fuseSplashScreenService.hide();
      this.router.navigateByUrl(`dac6-reporter/pre-arrangement/detail/${state.Payload.Id}`);
    });
  }

  startDataSurvey() {
    const {flag} = this.selectedBasket;
    const bucket = flag === 'MX' ? '-MX' : '';
    const title = `Arrangement${bucket}`;
    const parameters = {'SourceTypes': [`Arrangement${bucket}`, `Relevant-Taxpayers${bucket}`, `Intermediaries${bucket}`, `Other-Persons${bucket}`]};
    this.dialogService.createOrLoadDefaultSurveyTemplate(title, false, false, null, parameters);
  }

  import() {
    this.router.navigateByUrl('dac6-reporter/arrangement/import');
    // this.router.navigate(['import'], {relativeTo: this.activatedRoute});
  }

  deleteTransactions() {
    this.flag = true;
    this.deleteDisabled = true;
  }
  startConversationActivity(event) {
    let startConversationCommand = new PlatformCommand('OpenConversationActivityCommand','Dac6Api');
    var sourceKey = BasketProvider.getRootSourceKeyBySourceType(event.item.type);
    startConversationCommand.fieldValues['SourceType'] = sourceKey;
    // viewDocumentCommand.fieldValues[sourceKey+"Id"] = event.item.id;
    startConversationCommand.fieldValues['CaseId'] = event.item.id;
    this.commandService.executePlatformCommand(startConversationCommand).pipe(take(1)).subscribe(response => {
        console.log('commandState', response);
      },
      error => {
        console.error('Failed to basket manage section', error);
      });
  }

  onGridCellValueChange(event) {
    if (event.fieldDefinition && event.fieldDefinition.key === 'CaseId') {
      // this.router.navigate(['./detail', event.item.id], {relativeTo: this.activatedRoute});
      this.router.navigateByUrl(`dac6-reporter/arrangement/${event.item.id}`);
      return;
    }
    if (event.fieldDefinition && event.fieldDefinition.key === 'Suggested_Hallmarks') {
      this.dialogService.showCellEditorDialog(event.item, event.fieldDefinition, '500px', '500px').subscribe();
      return;
    }
    if (event.action) {
      switch (event.action.id) {
        case 'Open':
          // this.router.navigate(['detail/', event.item.id], {relativeTo: this.activatedRoute});
          this.router.navigateByUrl(`dac6-reporter/arrangement/${event.item.id}`);
          break;
        case 'OpenHallmarkQuestion':
          this.navigateToDetailViewerTab(event.fieldDefinition, event.item);
          break;
        case 'Edit':
          this.edit(event);
          break;
        case 'itemClick':
          this.handleItemClick(event);
          break;
        case 'OpenCaseFolder':
          let viewDocumentCommand = new PlatformCommand('ViewDocumentActivityCommand','Dac6Api');
          var sourceKey = BasketProvider.getRootSourceKeyBySourceType(event.item.type);
          viewDocumentCommand.fieldValues['SourceType'] = sourceKey;
          // viewDocumentCommand.fieldValues[sourceKey+"Id"] = event.item.id;
          viewDocumentCommand.fieldValues['CaseId'] = event.item.id;
          this.commandService.executePlatformCommand(viewDocumentCommand).pipe(take(1)).subscribe(response => {
              console.log('commandState', response);
            },
            error => {
              console.error('Failed to basket manage section', error);
            });
          this.navigateToCaseFolder(event);
          break;
        case 'Start Conversation':
          this.startConversationActivity(event);
          this.getChatForThisCase(event);
          break;
        case 'ArchiveCase':
          this.archiveSingle(event.item.cells['CaseGUID'].value);
          break;
        case 'UnarchiveCase':
          this.unarchiveCase(event.item.cells['CaseGUID'].value);
          break;
        /*case 'Move to Arrangements':
         break;
         case 'CreateMonthlyFiling':
         this.createMonthlyFiling(event.item);
         break;
         case 'CreateQuarterlyFiling':
         this.createQuarterlyFiling(event.item);
         break;
         case 'MarkAnnualFiling':
         this.markAnnualFiling(event.item);
         break;*/
        case 'MoveToMonthly':
          this.copyOrMove(event.item, FilingTypes.Dac6MonthlyFiling, false, 'dac6-reporter/arrangement/filing/monthly', event.action.id);
          break;
        case 'MoveToOther':
          this.copyOrMove(event.item, FilingTypes.Dac6OtherFiling, false, 'dac6-reporter/arrangement/filing/other', event.action.id);
          break;
        case 'MoveToQuarterly':
        case 'CopyToQuarterly':
          if (event.item.cells[ArrangementFields.FilingStages] && event.item.cells[ArrangementFields.FilingStages].value === FilingStages.CopiedToQuarterly) {
            this.dialogService.showDialogMessage('Message', 'This arrangement is already copied to Quarterly Filing. You cannot copy this again.');
          } else if (event.item.cells[ArrangementFields.FilingStages] && event.item.cells[ArrangementFields.FilingStages].value === FilingStages.CopiedToAnnually) {
            this.dialogService.showDialogMessage('Message', 'This arrangement is already copied to Annual Filing. You cannot copy this to Quarterly Filing.');
          } else {
            this.copyOrMove(event.item, FilingTypes.Dac6QuarterlyFiling, event.action.id === 'CopyToNextQuarter', `dac6-reporter/arrangement/filing/${FilingPeriod.QuarterlyId(new Date(Date.now()))}`, event.action.id);
          }
          break;
        case 'CopyToNextQuarter':
          if (event.item.cells[ArrangementFields.FilingStages].value === FilingStages.CopiedToNextQuarter) {
            this.dialogService.showDialogMessage('Message', 'This arrangement is already copied to next quarter. You cannot copy this again.');
          } else {
            const qId = FilingPeriod.QuarterlyId(new Date(Date.now()));
            if (qId === event.item.cells[CommonFields.FiledPeriodId].value) {
              var message = 'This arrangement can be copied after ending of current quarter.';
              if (event.item.cells['MarketableArrangement'] && event.item.cells['MarketableArrangement'].value) {
                message = 'Additional reporting of marketable arrangements must be completed  every 3 months.';
              }
              this.dialogService.showDialogMessage('Message', message);
            } else {
              this.copyOrMove(event.item, FilingTypes.Dac6QuarterlyFiling, event.action.id === 'CopyToNextQuarter', `dac6-reporter/arrangement/filing/${qId}`, event.action.id);
            }
          }
          break;
        case 'MoveToYearly':
        case 'CopyToYearly':
          if (event.item.cells[ArrangementFields.FilingStages] && event.item.cells[ArrangementFields.FilingStages].value === FilingStages.CopiedToQuarterly) {
            this.dialogService.showDialogMessage('Message', 'This arrangement is already copied to Quarterly Filing. You cannot copy this to Annual Filing.');
          } else if (event.item.cells[ArrangementFields.FilingStages] && event.item.cells[ArrangementFields.FilingStages].value === FilingStages.CopiedToAnnually) {
            this.dialogService.showDialogMessage('Message', 'This arrangement is already copied to Annual Filing. You cannot copy this to again.');
          } else {
            this.copyOrMove(event.item, FilingTypes.Dac6YearlyFiling, event.action.id === 'CopyToNextYear', `dac6-reporter/arrangement/filing/${FilingPeriod.YearlyId(new Date(Date.now()).getFullYear())}`, event.action.id);
          }
          break;
        case 'CopyToNextYear':
          if (event.item.cells[ArrangementFields.FilingStages].value === FilingStages.CopiedToNextYear) {
            this.dialogService.showDialogMessage('Message', 'This arrangement is already copied to next year. You cannot copy this again.');
          } else {
            const yId = FilingPeriod.YearlyId(new Date(Date.now()).getFullYear());
            if (yId === event.item.cells[CommonFields.FiledPeriodId].value) {
              this.dialogService.showDialogMessage('Message', 'This arrangement can be copied after ending of current year.');
            } else {
              this.copyOrMove(event.item, FilingTypes.Dac6YearlyFiling, event.action.id === 'CopyToNextYear', `dac6-reporter/arrangement/filing/${yId}`, event.action.id);
            }
          }
          break;
        case 'CreateDueDate':
          if (ArrangementBasketHelper.isCreateDueDateValid(event.item)) {
            this.createDueDate(event.item, event.action.id);
          } else {
            const errorMessage = ArrangementBasketHelper.dueDateCreationInvalidMessage();
            this.dialogService.showDialogMessage('Message', errorMessage);
          }
          break;
        case 'AssignTransactions':
          if (event.item.cells[ArrangementFields.CountryToReport] && event.item.cells[ArrangementFields.ReportingEntity] && event.item.cells[ArrangementFields.ReportingDueDate]) {
            this.router.navigateByUrl('dac6-reporter/transactions');
          } else {
            this.dialogService.showDialogMessage('Message', 'Please select Country to Report, Reporting Entity & Reporting Date before assigning transaction.');
          }
          break;
        case 'Delete':
          const command = new ArrangeMentsDeleteCommand([event.item.id]);
          this.commandService.executeCommand(command).subscribe(state => {
            if (state) {
              this.invalidateSubject.invalidate();
              this.snackBarService.showInformation('Arrangement Deleted Successfully');
            }
          });
          break;
        case 'Copy':
          this.copyCase(event);
          break;
        case 'ViewActivity':
          this.trackCaseActiviy(event);
          break;
      }
    }
    console.log(event);
  }

  getChatForThisCase(event) {
    const sourceInfoDictionary = {
      'sourceInfoDictionary': {
        CaseGuid: event.item.cells['CaseGUID'].value,
        caseId: event.item.cells['CaseId'].displayText
      }
    };
    console.log('event:', event);
    const createChatConversationCommand = new CreateChatConversationCommand(
      '[COMPANY_ID]-chat',
      `${event.item.cells['CaseId'].displayText}`,
      true,
      0,
      'DAC6',
      [],
      true,
      event.item.cells['CaseGUID'].value,
      sourceInfoDictionary
    );
    createChatConversationCommand.scope = ContentScope.Company;
    this.collaborationStore.dispatch(new CreateChatConversationAction(createChatConversationCommand, ConversationComponentName));
  }

  navigateToCaseFolder(event: any) {
    console.log('navigateToCaseFolder', event);
    if (event.action && event.action.tags.length) {
      let relativePath = event.action.tags[0];
      const caseId = event.item.cells['CaseId'].displayText;
      relativePath = relativePath.replace('[CASE_ID]', caseId);
      console.log('rellativePath', relativePath);
      // const relativeUrl$ = this.queryState.pipe(select(getQueryResponse, 'UrlByRelativePath'))
      //   .pipe(take(2));
      // relativeUrl$.subscribe(state => {
      //   console.log('RelativeUrl', state);
      //   if (state) {
      //     this.router.navigateByUrl(state);
      //   }
      // });

      // QueryProvider.invokeQuery(this.queryState, 'UrlByRelativePath', {'[RELATIVE_PATH]': relativePath});
      this.fileStoreCommonService.navigateToClientFolderUsingRelativepath(relativePath);

    }
  }

  createFilingFromArrangement(arrangement: any, filingType: string, actionid = null) {
    if (arrangement.cells['IsFilingCreated'] && arrangement.cells['IsFilingCreated'].value === true) {
      this.router.navigateByUrl(`dac6-reporter/filing/${filingType}`);
      return;
    }
    const selectionKey = 'create-filing-from-arrangement';
    const preCommand = new SaveSelectedArrangementsInLeftSideOfTheTransferboxCommand(selectionKey, arrangement.id);
    this.commandService.executeCommand(preCommand).subscribe(prestate => {
      if (prestate) {
        this.openTransferboxToCreateFiling(arrangement, filingType, selectionKey, actionid);
      }
    });
  }

  openTransferboxToCreateFiling(arrangement: any, filingType: string, selectionKey: string, actionid = null) {
    const metaData = {
      arrangement: arrangement,
      filingType: filingType,
      selectionKey: selectionKey,
      actionId: actionid
    };
    ArrangementBasketHelper.createFilinngStepper(metaData, this.router, this.commandService, this.dialogService, this.fuseSplashScreenService);
    /*const input = {
      ['SELECTION_KEY']: selectionKey,
      ['ITEM_ACTION_ID']: actionid
    };
    const dialogModel = DialogModel.create('Select arrangement to create filing', 'EntitySelectorDialogComponent', {
      filterId: arrangement.id,
      filterTemplateId: 'dac6-create-filing-from-arrangement-filter',
      apiKey: 'Dac6Api',
      message: `Note: To create filing record(s), please select from the available Cases listed below and click 'Done'. The Case you chose initially has already been selected. If you can't see certain Cases here, it may be because you haven't yet provided the mandatory Country to Report, Reporting Entity and Reporting Date information via the Arrangements screen.`,
      input: input
    });
    dialogModel.isFullscreen = true;
    if (filingType === 'monthly') {
      dialogModel.okCaption = 'Next';
    }
    this.dialogService.showOkCancelDialog(dialogModel)
      .pipe(takeUntil(this.unSubscribe$))
      .subscribe(actionState => {
        if (actionState && actionState.action === 'OK') {
          if (filingType === 'monthly') {
            let marketebleSelectionKey = 'marked-marketable-arrangement';
            const marketableDialogModel = DialogModel.create('Select marketable arrangements', 'EntitySelectorDialogComponent', {
              filterId: arrangement.id,
              filterTemplateId: 'dac6-select-marketable-arrangement-filter',
              apiKey: 'Dac6Api',
              message: `Note: The selected case(s) will automatically be added to the quarterly reporting tabs.`,
              input: {
                ['SELECTION_KEY']: marketebleSelectionKey,
                ['OLD_FILTER']: arrangement.id,
                ['OLD_SELECTION']: selectionKey
              }
            });
            marketableDialogModel.isFullscreen = true;
            this.dialogService.showOkCancelDialog(marketableDialogModel)
              .pipe(takeUntil(this.unSubscribe$))
              .subscribe(actionState => {
                if (actionState && actionState.action === 'OK') {
                  this.fuseSplashScreenService.show();
                  var command = new CreateMonthlyFilingCommand(arrangement.id);
                  this.commandService.executeCommand(command).subscribe(state => {
                    this.fuseSplashScreenService.hide();
                    if (state) {
                      this.router.navigateByUrl(`dac6-reporter/filing/${filingType}`);
                    }
                  }, error => {
                    console.log(error);
                    this.fuseSplashScreenService.hide();
                  });
                }
              });
          }
          else if (filingType === 'quarterly') {
            var command = new CreateQuarterlyFilingCommand(arrangement.id);
            this.commandService.executeCommand(command).subscribe(state => {
              if (state) {
                this.router.navigateByUrl(`dac6-reporter/filing/${filingType}`);
              }
            });
          }
        }
      });*/
  }


  createDueDate(item: any, actionid = null) {
    this.createFilingFromArrangement(item, item.cells.Tag.value.toString().toLowerCase(), actionid);
  }

  copyOrMove(arrangement: any, filingType: string, nextIteration: boolean, redirectUrl: string, actionid = null) {
    const isCopy = this.isCopyArrangement(arrangement, nextIteration);
    const selectionKey = this.getSelectionKeyForCopyOrMove(isCopy);
    const preCommand = new SaveSelectedArrangementsInLeftSideOfTheTransferboxCommand(selectionKey, arrangement.id);
    this.commandService.executeCommand(preCommand).subscribe(prestate => {
      if (prestate) {
        this.openTranseFerboxToCopyOrMove(arrangement.id, filingType, nextIteration, redirectUrl, selectionKey, isCopy, actionid);
      }
    });
  }

  isCopyArrangement(arrangement: any, nextIteration: boolean): boolean {
    const isCopy = nextIteration || (arrangement.cells[ArrangementFields.Tag].value !== 'NotFiled' && arrangement.cells[ArrangementFields.Tag].value !== 'NotFiledArchived');
    return isCopy;
  }

  getSelectionKeyForCopyOrMove(isCopy: boolean): string {
    return isCopy ? 'copy-arrangement' : 'move-arrangement';
  }

  openTranseFerboxToCopyOrMove(arrangementId: string, filingType: string, nextIteration: boolean, redirectUrl: string, selectionKey: string, isCopy: boolean, actionid = null) {
    const input = {
      ['SELECTION_KEY']: selectionKey,
      ['ITEM_ACTION_ID']: actionid
    };
    const dialogModel = DialogModel.create('Select', 'EntitySelectorDialogComponent', {
      filterId: arrangementId,
      filterTemplateId: 'dac6-copy-or-move-arrangement-filter',
      apiKey: 'Dac6Api',
      input: input
    });
    dialogModel.isFullscreen = true;

    this.dialogService.showOkCancelDialog(dialogModel)
      .pipe(takeUntil(this.unSubscribe$))
      .subscribe(actionState => {
        if (actionState && actionState.action === 'OK') {
          this.fuseSplashScreenService.show();
          const command = new CopyOrMoveForFilingCommand(arrangementId, filingType, nextIteration, isCopy);
          this.commandService.executeCommand(command).subscribe(state => {
            this.fuseSplashScreenService.hide();
            if (redirectUrl !== '') {
              this.router.navigateByUrl(redirectUrl);
            } else {
              this.invalidateSubject.invalidate();
            }
          }, error => {
            console.log(error);
            this.fuseSplashScreenService.hide();
          });
        }
      });

  }

  markAnnualFiling(arrangement: any) {
    const command = new MarkAnnualFilingCommand(arrangement.id);
    this.commandService.executeCommand(command).subscribe(state => {
      this.invalidateSubject.invalidate();
    });
  }

  edit(event: any) {
    if (event.fieldDefinition.cellEditor === 'EntityTextCellEditor') {
      // Sync
      let command = new SyncProjectEntityToCompanyCommand(false);
      this.commandService.executeCommand(command).pipe().subscribe(commandState => {
        console.log(commandState);
        if (commandState.Payload.ConfirmationNeeded) {
          this.dialogService.showYesNoDialog('Confirm Sync', `You were working with the entities of project '${commandState.Payload.Configuration.ProjectModel.Name}'. Do you want to sync with the current project?`)
            .subscribe(state => {
              if (state.action === 'OK') {
                command = new SyncProjectEntityToCompanyCommand(true);
                this.commandService.executeCommand(command).pipe().subscribe(commandState2 => {
                  console.log(commandState2);
                  this.openEditor(event);
                });
              } else {
                this.openEditor(event);
              }
            });
        } else {
          this.openEditor(event);
        }
      });
      return;
    }
    this.openEditor(event);
  }

  public openEditor(event: any) {
    let minWidth = '1500px';
    const maxWidth = '1500px';
    if (event.fieldDefinition.key === 'ReportingEntity') {
      minWidth = '550px';
    }
    if (event.fieldDefinition.key === 'AssociateEnterprises') {
      minWidth = '760px';
      const sourceConfigKey = event.fieldDefinition.configKey;
      const config = Configuration.getSmartGridConfig(sourceConfigKey);
      config.Parameters['ID'] = event.item.id;
      this.particleCacheService.saveUserPreferenceGridSetting(Dynamic_Grid_Data_Request_Parameters, sourceConfigKey, config.Parameters);
    }
    if (event.fieldDefinition.key === 'CountryToReport') {
      minWidth = '600px';
    }
    if(event.fieldDefinition.dataType === 'Attachment'){
      minWidth = '550px';
      if(event.fieldDefinition.metaData['DirectoryPath']) {
        event.fieldDefinition.metaData['DirectoryPath'] = event.fieldDefinition.metaData['DirectoryPath'].replace('[CASE_ID]', event.item.cells['CaseId'].value);
      }
    }
    this.dialogService.showCellEditorDialog(event.item, event.fieldDefinition, minWidth, maxWidth, this.sourceType, this.fieldHistorySourceType).subscribe(state => {
      console.log('After Edit', state);
      if (state.action === 'OK') {
        this.saveFieldDefinition(state.data.input.fieldDefinition, event.fieldSection);
        const item = {id: event.item.id, fieldValues: {}};
        const value = event.item.cells[event.fieldDefinition.key].value;
        item.fieldValues[event.fieldDefinition.key] = value;
        if(event.fieldDefinition.dataType === 'Attachment'){
          item.fieldValues[`${event.fieldDefinition.key}FileName`]= event.item.cells['fileName'];
        }
        console.log(item);
        const command = new UpdateArrangementCommand(item);
        const currentBasket = BasketProvider.getCurrentBasket();
        switch (currentBasket.id){
          case BasketId.Mexico:
            command.IsHallmarkAutomatedCopy = true;
            break;
          default:
        }
        this.commandService.executeCommand(command).pipe().subscribe(commandState => {
          console.log(commandState);
          if(commandState.Payload.FieldValues[`${event.fieldDefinition.key}NoteAvailable`]){
            this.snackBarService.showInformation(commandState.Payload.FieldValues[`${event.fieldDefinition.key}NoteAvailable`]);
          }
          this.invalidateSubject.invalidate();
        });
      }
    });
  }

  saveFieldDefinition(fieldDefinition: any, selectedFieldSection: any) {
    let fieldSettings = null;
    if (fieldDefinition && fieldDefinition.configKey) {
      const fieldConfig = Configuration.getSmartGridConfig(fieldDefinition.configKey);
      if (fieldConfig && fieldConfig.FieldSettings) {
        fieldSettings = fieldConfig.FieldSettings;
      }
    }
    if (fieldSettings) {
      const rootUrlKey = Configuration.getSmartGridConfig(this.sourceType).RootUrlKey;
      const url = `${Configuration.getConfig(rootUrlKey)}FieldSection/UpdateFieldDefinition`;
      const config = Configuration.getSmartGridConfig(this.sourceType);
      if (config) {
        const sourceType = config.SourceType;
        const updateFieldDefinitionCommand = new UpdateFieldDefinitionCommand([fieldDefinition], selectedFieldSection.id, ParticleConfig.ApplicationId, sourceType, true,
          url, !Configuration.getSmartGridConfig(this.sourceType).IsCompanySpecific);
        this.commandService.executeCommand(updateFieldDefinitionCommand).pipe().subscribe(commandState => {
          this.invalidateSubject.invalidate();
        });
      }
      /*      const updateUrl = `${Configuration.getConfig('Dac6Api')}Command/UpdateCaseStatus`;
       const addCaseStatusCommand = new AddCaseStatusCommand([fieldDefinition],
       updateUrl, !Configuration.getSmartGridConfig(this.sourceType).IsCompanySpecific);
       this.commandService.executeCommand(addCaseStatusCommand).pipe().subscribe(commandState => {
       this.invalidateSubject.invalidate();
       });*/
    }
  }

  exportArrangement() {
    this.router.navigate(['export'], {
      relativeTo: this.activatedRoute,
      queryParams: {
        includeArchives: this.showArchived
      }
    });
  }

  private handleItemClick(event: any) {
    if (event.fieldDefinition.key === 'AssociateEnterprises') {
      this.openEditor(event);
      return;
    }
    console.log('handle click');
    const participantsId = this.formatFieldDefinitionKey(event.fieldDefinition.key);
    const url = `dac6-reporter/participants/${participantsId}/${event.item.cells['CaseId'].displayText}`;
    this.router.navigate([url]);
  }

  private formatFieldDefinitionKey(key: string) {
    return key === 'RelevantTaxpayers' ? 'relevant-taxpayers' : (key === 'Intermediaries' ? 'intermediaries' : (key === 'AssociateEnterprises' ? 'associate-enterprises' : 'other-persons'));
  }

  ngOnDestroy(): void {
    this.unSubscribe$.next();
    this.unSubscribe$.complete();
  }

  onFiledPeriodFilterChanged(filterName: string) {
    this.filedPeriod = filterName;
    this.config.Parameters['FILED_PERIOD'] = this.filedPeriod;
    this.particleCacheService.saveUserPreferenceGridSetting(Dynamic_Grid_Data_Request_Parameters, this.sourceType, this.config.Parameters);
    this.invalidateSubject.invalidate();
  }

  onDropDownSelectionChanged($event: BreadcrumbModel) {
    if (!$event) {
      return;
    }
    //this.setActiveFilingType($event);
    this.router.navigateByUrl($event.relativeUrl);
    //this.invalidateSubject.invalidate();
  }

  private setActiveFilingType($event: BreadcrumbModel) {
    this.breadcrumbs[2].id = $event.id;
    this.breadcrumbs[2].title = $event.title;
    this.breadcrumbs[2].relativeUrl = $event.relativeUrl;
    //this.filedPeriod = $event.id;
    this.config.Parameters['FILED_PERIOD'] = $event.id;
    this.particleCacheService.saveUserPreferenceGridSetting(Dynamic_Grid_Data_Request_Parameters, this.sourceType, this.config.Parameters);
    //this.router.navigateByUrl(this.breadcrumbs[2].relativeUrl);
  }

  public rowCallback = (context: RowClassArgs) => {
    return context.dataItem.isReadOnly ? 'row-locked' : '';
  };

  private copyCase(event: any) {
    var dialogModelTitle = 'Copy Case (' + event.item.cells.CaseId.displayText + ')';
    const dialogModel: DialogModel = DialogModel.create(
      dialogModelTitle,
      'CopyCaseDialogComponent',
      {'caseId': event.item.cells.CaseId.displayText, 'caseType': 'Arrangement', 'disableTypeChange': true, 'isReadOnly': event.item.isReadOnly, 'filedPeriodTitle': event.item.cells.FiledPeriodTitle.displayText, 'isArcived': event.item.cells.Archived.value},
      '600px',
      '700px',
    );
    this.dialogService.showOkCancelDialog(dialogModel).subscribe(res => {
      console.log(res);
      if (res.action === 'OK') {
        switch (res.data.input.caseType) {
          case 'Arrangement':
            if (res.data.input.specifyField) {
              res.data.input['title'] = event.item.cells.Title.value;
              this.openSelectFieldDialog(res.data.input.selectedCase, 'arrangementmodel', 'Arrangement', res, event.item.id, res.data.input.copyCount);
            } else {
              this.addArrangementFromExistingCaseId(event.item.cells.Title.value, event.item.id, res.data.input.archiveExisting, res.data.input.caseIdUsedforCorrection, res.data.input.copyCount);
            }
            break;
        }
      }

    });
  }

  private openSelectFieldDialog(selectedCase: string, dbmodelType: string, sourceType: string, caseData: any, existingId: string, copyCount: number = 1) {
    const dialogModel: DialogModel = DialogModel.create(
      'Select Data',
      'VirtualGridDialogComponent', {sourceKey: 'Dac6-RowFieldData-Config', params: {'rowId': selectedCase, 'dbmodelType': dbmodelType, 'sourceType': sourceType}},
    );
    dialogModel.isFullscreen = true;
    this.dialogService.showOkCancelDialog(dialogModel).subscribe(res => {
      if (res.action === 'OK') {
        switch (sourceType) {
          case 'Arrangement':
            this.addArrangementFromExistingCaseId(caseData.data.input.title, existingId, caseData.data.input.archiveExisting, false, copyCount, res.data.input.selectedFields, false);
            break;
        }
      }
    });
  }

  onBasketChange(event) {
    this.filterId = null;
    this.toggleAnnouncement(event);
    setTimeout(() => {
      this.filterId = Configuration.getBasketMappedSourceType('Arrangement');
    }, 200);
    this.dac6ReporterApiService.getArrangementBreadcrumbs().pipe(takeUntil(this.unSubscribe$)).subscribe(breadcrumbs => {
      if (breadcrumbs) {
        this.breadcrumbs[2].children = breadcrumbs;
        let selectedBreadCrumb = this.breadcrumbs[2].children.find(o => o.id === this.filedPeriod);
        if(!selectedBreadCrumb && this.breadcrumbs[2].children && this.breadcrumbs[2].children[0]){
          selectedBreadCrumb = this.breadcrumbs[2].children[0];
        }
        if(selectedBreadCrumb){
          this.setActiveFilingType(selectedBreadCrumb);
          this.router.navigateByUrl(selectedBreadCrumb.relativeUrl);
        }
      }
    });
  }

  dismissKey = 'arrangement-announcement-dismissed';

  private toggleAnnouncement(event) {
    if (event && event.id == 'dac6-eu' && !this.isAnnouncementDismissed()) {
      this.showAnnouncement = true;
    } else {
      this.showAnnouncement = false;
    }
  }

  onAnnouncementDismissed() {
    window.sessionStorage.setItem(this.dismissKey, 'dismissed')
  }

  private isAnnouncementDismissed() {
    if(window.sessionStorage.getItem(this.dismissKey))
      return true;
    return false;
  }

  private navigateToDetailViewerTab(fieldDefinition, item) {
    if (item.cells[fieldDefinition.key].value !== 'Yes') {
      return ;
    }
    const fieldSectionKey = fieldDefinition.metaData['ChildHallmarkFieldSectionKey'];
    let selectedFieldSectionTabIndex = 0;
    for (let i = 0 ; i < this.tabs.length ; i++) {
      if (this.tabs[i].headerKey && this.tabs[i].headerKey === fieldSectionKey){
        selectedFieldSectionTabIndex = i;
        break;
      }
    }
    let routingPath = `dac6-reporter/arrangement/${item.id}?selectedTab=${selectedFieldSectionTabIndex}`;;
    this.router.navigateByUrl(routingPath);
  }
}
